export default {
  handleStatusAgentsSort(agentsList, descending) {
    const initiating = [];
    const helping = [];
    const updating = [];
    const offline = [];
    const ready = [];
    const rest = [];
    agentsList.forEach(item => {
      switch (item.Status) {
        case 'Busy':
          initiating.push(item);
          break;
        case 'Initiating':
          initiating.push(item);
          break;
        case 'Helping':
          helping.push(item);
          break;
        case 'Offline':
          offline.push(item);
          break;
        case 'Ready':
          ready.push(item);
          break;
        case 'Updating':
          updating.push(item);
          break;
        default:
          rest.push(item);
          break;
      }
    });
    return descending ? [...rest, ...updating, ...ready, ...offline, ...initiating, ...helping] : [...helping, ...initiating, ...offline, ...ready, ...updating, ...rest];
  },
  handleDuplicateAgentsSort(agentsList) {
    const duplicateAgents = [];
    const restAgents = [];
    agentsList.forEach(item => {
      if (item.ibxMeta.isAgentDuplicateLicense) {
        duplicateAgents.push(item);
      } else restAgents.push(item);
    });
    if (duplicateAgents.length > 0) {
      duplicateAgents[duplicateAgents.length - 1].lastDuplicate = 1;
    }
    const updateAgentsList = [...duplicateAgents, ...restAgents];
    return updateAgentsList;
  },

  findAgentValueFromSortKey(agent, key) {
    const map = {
      name: e => e.Name,
      AvailableCores: e => e.CoresUsed,
      cpu: e => e.Performance.AvailCPU,
      cache: e => e.Performance.CasheUsed,
      Network: e => e.NetworkInfo,
      LastConnected: e => e.LastConnected,
      LoggedUsers: e => e.LoggedUsers,
      status: e => e.Status,
      alerts: e => (e.Errors ? 2 : 0) + !!e.Warnings,
      buildGroup: e => e.buildGroup,
    };
    if (map[key]) return map[key](agent);
    throw new Error(`findAgentValueFromSortKey couldn't find "${key}" for mapping`);
  },

  sortAgents(agents, pagination, mutateCallback) {
    const { sortBy, descending } = pagination;
    const equalValueHandler = (a, b) => {
      if (descending) return a.Name < b.Name ? 1 : -1;
      return b.Name < a.Name ? 1 : -1;
    };
    switch (sortBy) {
      case 'name':
        agents.sort((a, b) => {
          const nameA = a.Name?.toLowerCase ? a.Name.toLowerCase() : String(a.Name);
          const nameB = b.Name?.toLowerCase ? b.Name.toLowerCase() : String(b.Name);
          if (descending) return nameA < nameB ? 1 : -1;
          return nameB < nameA ? 1 : -1;
        });
        return sortBy;
      case 'AvailableCores':
        agents.sort((a, b) => {
          if (a.CoresUsed === b.CoresUsed) return equalValueHandler(a, b);
          if (descending) return a.CoresUsed < b.CoresUsed ? 1 : -1;
          return b.CoresUsed < a.CoresUsed ? 1 : -1;
        });
        return sortBy;
      case 'cpu':
        agents.sort((a, b) => {
          if (a.Performance.AvailCPU === b.Performance.AvailCPU) return equalValueHandler(a, b);
          if (descending) return a.Performance.AvailCPU < b.Performance.AvailCPU ? 1 : -1;
          return b.Performance.AvailCPU < a.Performance.AvailCPU ? 1 : -1;
        });
        return sortBy;
      case 'cache':
        agents.sort((a, b) => {
          if (a.Performance.CasheUsed === b.Performance.CasheUsed) return equalValueHandler(a, b);
          if (descending) return a.Performance.CasheUsed < b.Performance.CasheUsed ? 1 : -1;
          return b.Performance.CasheUsed < a.Performance.CasheUsed ? 1 : -1;
        });
        return sortBy;
      case 'Network':
        agents.sort((a, b) => {
          const NetworkInfoA = a.NetworkInfo?.toLowerCase ? a.NetworkInfo.toLowerCase() : String(a.NetworkInfo);
          const NetworkInfoB = b.NetworkInfo?.toLowerCase ? b.NetworkInfo.toLowerCase() : String(b.NetworkInfo);
          if (NetworkInfoA === NetworkInfoB) return equalValueHandler(a, b);
          if (descending) return NetworkInfoA < NetworkInfoB ? 1 : -1;
          return NetworkInfoB < NetworkInfoA ? 1 : -1;
        });
        return sortBy;
      case 'LastConnected':
        agents.sort((a, b) => {
          const dateA = new Date(a.LastConnected)?.setSeconds(0, 0);
          const dateB = new Date(b.LastConnected)?.setSeconds(0, 0);
          if (dateA === dateB) return equalValueHandler(a, b);
          if (descending) return dateA < dateB ? 1 : -1;
          return dateB < dateA ? 1 : -1;
        });
        return sortBy;
      case 'LoggedUsers':
        agents.sort((a, b) => {
          const LoggedUsersA = a.LoggedUsers?.toLowerCase ? a.LoggedUsers.toLowerCase() : String(a.LoggedUsers);
          const LoggedUsersB = b.LoggedUsers?.toLowerCase ? b.LoggedUsers.toLowerCase() : String(b.LoggedUsers);
          if (LoggedUsersA === LoggedUsersB) return equalValueHandler(a, b);
          if (descending) return LoggedUsersA < LoggedUsersB ? 1 : -1;
          return LoggedUsersB < LoggedUsersA ? 1 : -1;
        });
        return sortBy;
      case 'alerts':
        agents.sort((a, b) => {
          const aScore = (a.Errors ? 2 : 0) + !!a.Warnings;
          const bScore = (b.Errors ? 2 : 0) + !!b.Warnings;
          if (aScore === bScore) return equalValueHandler(a, b);
          if (descending) return aScore < bScore ? -1 : 1;
          return bScore < aScore ? -1 : 1;
        });
        return sortBy;
      case 'status':
        if (mutateCallback) mutateCallback(this.handleStatusAgentsSort(agents, descending));
        else throw new Error('sortAgents by status required mutateCallback for new array assignment');
        return sortBy;
      case 'buildGroup':
        agents.sort((a, b) => {
          const buildGroupA = a.buildGroup?.toLowerCase ? a.buildGroup.toLowerCase() : String(a.buildGroup);
          const buildGroupB = b.buildGroup?.toLowerCase ? b.buildGroup.toLowerCase() : String(b.buildGroup);
          if (buildGroupA === buildGroupB) return equalValueHandler(a, b);
          if (descending) return buildGroupA < buildGroupB ? 1 : -1;
          return buildGroupB < buildGroupA ? 1 : -1;
        });
        return sortBy;
      case 'ip':
        agents.sort((a, b) => {
          const ipA = a.IP?.toLowerCase ? a.IP.toLowerCase() : String(a.IP);
          const ipB = b.IP?.toLowerCase ? b.IP.toLowerCase() : String(b.IP);
          if (ipA === ipB) return equalValueHandler(a, b);
          if (descending) return ipA < ipB ? 1 : -1;
          return ipB < ipA ? 1 : -1;
        });
        return sortBy;
      case 'license':
        return sortBy;
      default:
        return false;
    }
  },
};
